// src/DimensionnementPompeModal.js
import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { loadProductImages, getProductImage } from './productImages';
import { X, Droplets, Search, ChevronDown, ChevronUp } from 'lucide-react';

const USD_TO_FCFA = 655.957;
const prixVente = (usd) => Math.round(usd * 2 * 1.3 * USD_TO_FCFA / 1000) * 1000;

const accessoires = (pw) => {
  if (pw <= 1500)   return 185570;
  if (pw <= 3000)   return 280000;
  if (pw <= 5500)   return 420000;
  if (pw <= 9200)   return 580000;
  if (pw <= 15000)  return 850000;
  if (pw <= 30000)  return 1200000;
  return null;
};

const installation = (pw) => {
  if (pw <= 500)    return 65290;
  if (pw <= 1500)   return 75290;
  if (pw <= 3000)   return 120000;
  if (pw <= 5500)   return 180000;
  if (pw <= 9200)   return 280000;
  if (pw <= 15000)  return 420000;
  if (pw <= 30000)  return 650000;
  return null;
};

const PANNEAU_PRIX = 152220;
const nbPanneaux = (pw) => Math.max(2, Math.ceil((pw * 1.5) / 545));

const PETITES_POMPES = [
  { ref: 'PSB-200H52S08', type: 'S', puissanceW: 200,  hmtMax: 52,  debitMax: 1.5,  prix: 414960,  accessoires: 185570, vedette: true,  label: 'Puits/Forage — 52m max, 1.5m3/h' },
  { ref: 'PSB-3500HS012S', type: 'S', puissanceW: 500,  hmtMax: 69,  debitMax: 2.5,  prix: 515708,  accessoires: 185570, vedette: true,  label: 'Puits/Forage — 69m max, 2.5m3/h' },
  { ref: 'PSB-3600S025S',  type: 'S', puissanceW: 600,  hmtMax: 44,  debitMax: 3.5,  prix: 528470,  accessoires: 185570, vedette: true,  label: 'Puits/Forage — 44m max, 3.5m3/h' },
  { ref: 'PSB-31100S030S', type: 'S', puissanceW: 1100, hmtMax: 73,  debitMax: 4.0,  prix: 534960,  accessoires: 185570, vedette: true,  label: 'Puits/Forage — 73m max, 4.0m3/h' },
  { ref: 'PSB-31500S040S', type: 'S', puissanceW: 1500, hmtMax: 69,  debitMax: 5.5,  prix: 622440,  accessoires: 233960, vedette: true,  label: 'Puits/Forage — 69m max, 5.5m3/h' },
  { ref: 'PSB-31100S035S', type: 'S', puissanceW: 1100, hmtMax: 56,  debitMax: 4.5,  prix: 534960,  accessoires: 185570, vedette: false, label: 'Puits/Forage — 56m max, 4.5m3/h' },
  { ref: 'PSB-31500S030S', type: 'S', puissanceW: 1500, hmtMax: 93,  debitMax: 4.0,  prix: 622440,  accessoires: 185570, vedette: false, label: 'Puits/Forage — 93m max, 4.0m3/h' },
  { ref: 'PSB-41500S060S', type: 'S', puissanceW: 1500, hmtMax: 40,  debitMax: 8.0,  prix: 622440,  accessoires: 185570, vedette: false, label: 'Puits/Forage — 40m max, 8.0m3/h' },
  { ref: 'PSB-41500S100S', type: 'S', puissanceW: 1500, hmtMax: 30,  debitMax: 13.0, prix: 622440,  accessoires: 185570, vedette: false, label: 'Puits/Forage — 30m max, 13.0m3/h' },
  { ref: 'PSB-41500S110S', type: 'S', puissanceW: 1500, hmtMax: 14,  debitMax: 14.0, prix: 622440,  accessoires: 185570, vedette: false, label: 'Puits/Forage — 14m max, 14.0m3/h' },
  { ref: 'PSB-61500S160S', type: 'S', puissanceW: 1500, hmtMax: 18,  debitMax: 21.0, prix: 670852,  accessoires: 256890, vedette: false, label: 'Puits/Forage — 18m max, 21.0m3/h' },
  { ref: 'PSB-3300C018S',  type: 'S', puissanceW: 300,  hmtMax: 19,  debitMax: 2.5,  prix: 480000,  accessoires: 185570, vedette: false, label: 'Surface — 19m max, 2.5m3/h' },
  { ref: 'PSB-3600C020S',  type: 'S', puissanceW: 600,  hmtMax: 46,  debitMax: 3.0,  prix: 520000,  accessoires: 185570, vedette: false, label: 'Surface — 46m max, 3.0m3/h' },
  { ref: 'PSB-31100C025S', type: 'S', puissanceW: 1100, hmtMax: 73,  debitMax: 3.5,  prix: 534960,  accessoires: 185570, vedette: false, label: 'Surface — 73m max, 3.5m3/h' },
  { ref: 'PSB-31500C025S', type: 'S', puissanceW: 1500, hmtMax: 87,  debitMax: 3.5,  prix: 770852,  accessoires: 256890, vedette: false, label: 'Surface — 87m max, 3.5m3/h' },
  { ref: 'PSB-3600C030S',  type: 'S', puissanceW: 600,  hmtMax: 29,  debitMax: 4.0,  prix: 520000,  accessoires: 185570, vedette: false, label: 'Surface — 29m max, 4.0m3/h' },
  { ref: 'PSB-31100C040S', type: 'S', puissanceW: 1100, hmtMax: 55,  debitMax: 5.5,  prix: 534960,  accessoires: 185570, vedette: false, label: 'Surface — 55m max, 5.5m3/h' },
  { ref: 'PSB-31500C040S', type: 'S', puissanceW: 1500, hmtMax: 71,  debitMax: 5.5,  prix: 622440,  accessoires: 185570, vedette: false, label: 'Surface — 71m max, 5.5m3/h' },
  { ref: 'PSB-41100C070S', type: 'S', puissanceW: 1100, hmtMax: 31,  debitMax: 9.0,  prix: 518700,  accessoires: 256890, vedette: false, label: 'Surface — 31m max, 9.0m3/h' },
  { ref: 'PSB-41500C080S', type: 'S', puissanceW: 1500, hmtMax: 38,  debitMax: 10.5, prix: 672680,  accessoires: 256890, vedette: false, label: 'Surface — 38m max, 10.5m3/h' },
];

const POMPES_SURFACE = [
  // DC petites puissances
  { ref: 'PSB-SDC-150W-16m',  type: 'surface', puissanceW: 150,   hmtMax: 16,  debitMax: 1.3,  prix: 328000,  accessoires: 0, vedette: true,  label: 'DC 150W — 16m max, 1.3m³/h' },
  { ref: 'PSB-SDC-250W-28m',  type: 'surface', puissanceW: 250,   hmtMax: 28,  debitMax: 2.0,  prix: 334100,  accessoires: 0, vedette: true,  label: 'DC 250W — 28m max, 2.0m³/h' },
  { ref: 'PSB-SDC-400W-25m',  type: 'surface', puissanceW: 400,   hmtMax: 25,  debitMax: 0.7,  prix: 350500,  accessoires: 0, vedette: true,  label: 'DC 400W — 25m max, 0.7m³/h' },
  { ref: 'PSB-SDC-750W-25m',  type: 'surface', puissanceW: 750,   hmtMax: 25,  debitMax: 1.8,  prix: 536500,  accessoires: 0, vedette: true,  label: 'DC 750W — 25m max, 1.8m³/h' },
  { ref: 'PSB-SDC-750W-14m',  type: 'surface', puissanceW: 750,   hmtMax: 14,  debitMax: 20.0, prix: 873200,  accessoires: 0, vedette: true,  label: 'DC/AC 750W — 14m max, 20m³/h' },
  // AC grandes puissances
  { ref: 'SMARTPRO-S-1K1030', type: 'surface', puissanceW: 1100,  hmtMax: 30,  debitMax: 6.0,  prix: 488500,  accessoires: 0, vedette: true,  label: 'AC 1.1kW — 30m max, 6m³/h' },
  { ref: 'SMARTPRO-S-1K5050', type: 'surface', puissanceW: 1500,  hmtMax: 50,  debitMax: 8.5,  prix: 494300,  accessoires: 0, vedette: true,  label: 'AC 1.5kW — 50m max, 8.5m³/h' },
  { ref: 'SMARTPRO-S-2K2024', type: 'surface', puissanceW: 2200,  hmtMax: 24,  debitMax: 17.0, prix: 616520,  accessoires: 0, vedette: true,  label: 'AC 2.2kW — 24m max, 17m³/h' },
  { ref: 'SMARTPRO-S-3K0020', type: 'surface', puissanceW: 3000,  hmtMax: 20,  debitMax: 10.0, prix: 429000,  accessoires: 0, vedette: false, label: 'AC 3kW — 20m max, 10m³/h' },
  { ref: 'SMARTPRO-S-4K0080', type: 'surface', puissanceW: 4000,  hmtMax: 80,  debitMax: 9.0,  prix: 609960,  accessoires: 0, vedette: false, label: 'AC 4kW — 80m max, 9m³/h' },
  { ref: 'SMARTPRO-S-5K5079', type: 'surface', puissanceW: 5500,  hmtMax: 79,  debitMax: 20.0, prix: 714480,  accessoires: 0, vedette: false, label: 'AC 5.5kW — 79m max, 20m³/h' },
  { ref: 'SMARTPRO-S-7K5100', type: 'surface', puissanceW: 7500,  hmtMax: 100, debitMax: 17.0, prix: 982800,  accessoires: 0, vedette: false, label: 'AC 7.5kW — 100m max, 17m³/h' },
  { ref: 'SMARTPRO-S-11K030', type: 'surface', puissanceW: 11000, hmtMax: 30,  debitMax: 75.0, prix: 1179360, accessoires: 0, vedette: false, label: 'AC 11kW — 30m max, 75m³/h' },
  { ref: 'SMARTPRO-S-15K134', type: 'surface', puissanceW: 15000, hmtMax: 134, debitMax: 33.0, prix: 1575400, accessoires: 0, vedette: false, label: 'AC 15kW — 134m max, 33m³/h' },
  { ref: 'SMARTPRO-S-18K254', type: 'surface', puissanceW: 18500, hmtMax: 254, debitMax: 20.0, prix: 1818800, accessoires: 0, vedette: false, label: 'AC 18.5kW — 254m max, 20m³/h' },
  { ref: 'SMARTPRO-S-22K115', type: 'surface', puissanceW: 22000, hmtMax: 115, debitMax: 55.0, prix: 2200000, accessoires: 0, vedette: false, label: 'AC 22kW — 115m max, 55m³/h' },
  { ref: 'SMARTPRO-S-30K115', type: 'surface', puissanceW: 30000, hmtMax: 115, debitMax: 85.0, prix: 3000000, accessoires: 0, vedette: false, label: 'AC 30kW — 115m max, 85m³/h' },
  { ref: 'SMARTPRO-S-37K182', type: 'surface', puissanceW: 37000, hmtMax: 182, debitMax: 65.0, prix: 3802200, accessoires: 0, vedette: false, label: 'AC 37kW — 182m max, 65m³/h' },
];


const GRANDES_POMPES = [
  { ref: 'SmartPro-G3-3.7kW-S',  gamme: 'G3', puissanceKw: 3.7,  hmtMax: 123, debitMax: 5.0,   type: 'S', prixUSD: 361,  vedette: true,  label: 'Smart Pro G3 3.7kW — 123m max, 5m3/h' },
  { ref: 'SmartPro-G3-3.7kW-H',  gamme: 'G3', puissanceKw: 3.7,  hmtMax: 100, debitMax: 8.0,   type: 'S', prixUSD: 391,  vedette: true,  label: 'Smart Pro G3 3.7kW — 100m max, 8m3/h' },
  { ref: 'SmartPro-G3-5.5kW-H',  gamme: 'G3', puissanceKw: 5.5,  hmtMax: 150, debitMax: 10.0,  type: 'S', prixUSD: 529,  vedette: true,  label: 'Smart Pro G3 5.5kW — 150m max, 10m3/h' },
  { ref: 'SmartPro-G3-7.5kW-H',  gamme: 'G3', puissanceKw: 7.5,  hmtMax: 200, debitMax: 12.0,  type: 'S', prixUSD: 630,  vedette: true,  label: 'Smart Pro G3 7.5kW — 200m max, 12m3/h' },
  { ref: 'SmartPro-G3-11kW-H',   gamme: 'G3', puissanceKw: 11,   hmtMax: 250, debitMax: 18.0,  type: 'S', prixUSD: 873,  vedette: true,  label: 'Smart Pro G3 11kW — 250m max, 18m3/h' },
  { ref: 'SmartPro-G3-15kW-H',   gamme: 'G3', puissanceKw: 15,   hmtMax: 300, debitMax: 25.0,  type: 'S', prixUSD: 946,  vedette: true,  label: 'Smart Pro G3 15kW — 300m max, 25m3/h' },
  { ref: 'SmartPro-G3-18.5kW-H', gamme: 'G3', puissanceKw: 18.5, hmtMax: 350, debitMax: 30.0,  type: 'S', prixUSD: 1230, vedette: false, label: 'Smart Pro G3 18.5kW — 350m max, 30m3/h' },
  { ref: 'SmartPro-G3-22kW-H',   gamme: 'G3', puissanceKw: 22,   hmtMax: 400, debitMax: 40.0,  type: 'S', prixUSD: 1333, vedette: false, label: 'Smart Pro G3 22kW — 400m max, 40m3/h' },
  { ref: 'SmartPro-G3-30kW-H',   gamme: 'G3', puissanceKw: 30,   hmtMax: 450, debitMax: 60.0,  type: 'S', prixUSD: 1802, vedette: false, label: 'Smart Pro G3 30kW — 450m max, 60m3/h' },
  { ref: 'SmartPro-G3-37kW-H',   gamme: 'G3', puissanceKw: 37,   hmtMax: 500, debitMax: 80.0,  type: 'S', prixUSD: 2245, vedette: false, label: 'Smart Pro G3 37kW — 500m max, 80m3/h' },
  { ref: 'SmartPro-G3-45kW-H',   gamme: 'G3', puissanceKw: 45,   hmtMax: 600, debitMax: 100.0, type: 'S', prixUSD: 2649, vedette: false, label: 'Smart Pro G3 45kW — 600m max, 100m3/h' },
  { ref: 'SmartPro-G4-1.1kW',    gamme: 'G4', puissanceKw: 1.1,  hmtMax: 80,  debitMax: 3.0,   type: 'S', prixUSD: 254,  vedette: false, label: 'Smart Pro G4 1.1kW — 80m max, 3m3/h' },
  { ref: 'SmartPro-G4-1.5kW',    gamme: 'G4', puissanceKw: 1.5,  hmtMax: 100, debitMax: 4.0,   type: 'S', prixUSD: 258,  vedette: false, label: 'Smart Pro G4 1.5kW — 100m max, 4m3/h' },
  { ref: 'SmartPro-G4-2.2kW',    gamme: 'G4', puissanceKw: 2.2,  hmtMax: 120, debitMax: 5.0,   type: 'S', prixUSD: 267,  vedette: false, label: 'Smart Pro G4 2.2kW — 120m max, 5m3/h' },
  { ref: 'SmartPro-G4-3kW',      gamme: 'G4', puissanceKw: 3.0,  hmtMax: 150, debitMax: 7.0,   type: 'S', prixUSD: 275,  vedette: false, label: 'Smart Pro G4 3kW — 150m max, 7m3/h' },
];

const fmt = (n) => {
  if (n == null) return 'Sur devis';
  return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + ' FCFA';
};
const fmtN = (n) => Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');

// ── Calcul ROI pompe ──────────────────────────────────────────────────────────
const calculerROI = (pw, debitH, totalKit, settings) => {
  const puissanceKw = pw / 1000;
  const heuresJour = 6; // ensoleillement moyen Senegal
  const joursParMois = 30;

  // Prix depuis settings
  const tarifKwh   = parseFloat(settings.tarif_kwh)    || 189;
  const prixGasoil = parseFloat(settings.prix_gasoil)  || 680;
  const prixSeneau = parseFloat(settings.prix_seneau_m3) || 424;

  // Scenario 1 — SEN'EAU
  const volumeJour = debitH * heuresJour; // m3/jour
  const volumeMois = volumeJour * joursParMois;
  const ecoSeneauMois = volumeMois * prixSeneau;
  const roiSeneau = totalKit / ecoSeneauMois;

  // Scenario 2 — Groupe electrogene
  const consoCarbMois = puissanceKw * 0.3 * heuresJour * joursParMois; // litres/mois
  const ecoGasoilMois = consoCarbMois * prixGasoil;
  const roiGasoil = totalKit / ecoGasoilMois;

  // Scenario 3 — Pompe electrique SENELEC
  const kwhMois = puissanceKw * heuresJour * joursParMois;
  const ecoElecMois = kwhMois * tarifKwh;
  const roiElec = totalKit / ecoElecMois;

  const eco = (mensuel, ans) => mensuel * 12 * ans;

  return {
    seneau: {
      volumeJour: volumeJour.toFixed(1),
      volumeMois: volumeMois.toFixed(0),
      ecoMois: Math.round(ecoSeneauMois),
      roiMois: Math.ceil(roiSeneau),
      eco5: Math.round(eco(ecoSeneauMois, 5)),
      eco10: Math.round(eco(ecoSeneauMois, 10)),
      eco15: Math.round(eco(ecoSeneauMois, 15)),
      prixM3: prixSeneau,
    },
    gasoil: {
      litresJour: (puissanceKw * 0.3 * heuresJour).toFixed(1),
      litresMois: consoCarbMois.toFixed(0),
      ecoMois: Math.round(ecoGasoilMois),
      roiMois: Math.ceil(roiGasoil),
      eco5: Math.round(eco(ecoGasoilMois, 5)),
      eco10: Math.round(eco(ecoGasoilMois, 10)),
      eco15: Math.round(eco(ecoGasoilMois, 15)),
      prixLitre: prixGasoil,
    },
    elec: {
      kwhMois: kwhMois.toFixed(0),
      ecoMois: Math.round(ecoElecMois),
      roiMois: Math.ceil(roiElec),
      eco5: Math.round(eco(ecoElecMois, 5)),
      eco10: Math.round(eco(ecoElecMois, 10)),
      eco15: Math.round(eco(ecoElecMois, 15)),
      tarifKwh,
    },
  };
};

const DimensionnementPompeModal = ({ onClose, onSelect }) => {
  const [hmt, setHmt] = useState('');
  const [showIA, setShowIA] = useState(false);
  const [promptIA, setPromptIA] = useState('');
  const [loadingIA, setLoadingIA] = useState(false);
  const [debit, setDebit] = useState('');
  const [typePompe, setTypePompe] = useState('S');
  const [gamme, setGamme] = useState('petite');
  const [resultats, setResultats] = useState(null);
  const [selectionne, setSelectionne] = useState(null);
  const [showTous, setShowTous] = useState(false);
  const [pompesDB, setPompesDB] = useState([]);
  const [accDB, setAccDB] = useState({});
  const [accNomDB, setAccNomDB] = useState({});
  const [settings, setSettings] = useState({ tarif_kwh: 189, prix_gasoil: 680, prix_seneau_m3: 424 });

  useEffect(() => {
    loadProductImages();
    supabase.from('catalogue_produits').select('*').eq('actif', true).in('categorie', ['Pompes Solaires DC', 'Pompes Solaires AC', 'Pompes de Surface']).order('ordre')
      .then(({ data }) => { if (data && data.length > 0) setPompesDB(data); });
    supabase.from('catalogue_produits').select('ref,nom,prix').in('ref', ['ACC-CABLE-DC-6MM2','ACC-CABLE-IND-16MM2','ACC-CABLE-NIV-1.5MM2','ACC-BOITE-RACC','ACC-KIT-TERRE','ACC-TUBE-IRL-50M','ACC-TUBE-T13-100M','ACC-CABLE-ACIER','ACC-SUPPORTS-PV-METAL','ACC-STRUCTURE-PV-INOX','JKM545M-72HL4-BDVP','PRESTA-INSTALL-PV'])
      .then(({ data }) => { if (data) { const m = {}; const mn = {}; data.forEach(p => { m[p.ref] = p.prix; mn[p.ref] = p.nom; }); setAccDB(m); setAccNomDB(mn); } });

    supabase.from('settings').select('cle, valeur')
      .then(({ data }) => {
        if (data) {
          const s = {};
          data.forEach(r => { s[r.cle] = r.valeur; });
          setSettings(prev => ({ ...prev, ...s }));
        }
      });
  }, []);

  const analyserIA = async () => {
    if (!promptIA.trim()) return;
    setLoadingIA(true);
    try {
      const res = await fetch('https://api.groq.com/openai/v1/chat/completions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer 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' },
        body: JSON.stringify({
          model: 'llama-3.3-70b-versatile',
          messages: [{
            role: 'system',
            content: 'Tu es un expert en pompage solaire au Sénégal. Analyse la description et retourne UNIQUEMENT un JSON: {"hmt": number, "debit": number}. HMT = profondeur du puits/forage + 10m de pertes de charge minimum (toujours arrondir au supérieur). Débit en m3/h. Ne jamais sous-estimer le HMT.'
          }, { role: 'user', content: promptIA }],
          temperature: 0.1, max_tokens: 200
        })
      });
      const data = await res.json();
      let content = data.choices?.[0]?.message?.content || '{}';
      content = content.replace(/```json/g, '').replace(/```/g, '').trim();
      const parsed = JSON.parse(content);
      if (parsed.hmt) setHmt(String(parsed.hmt));
      if (parsed.debit) setDebit(String(parsed.debit));
      setShowIA(false); setPromptIA('');
    } catch(e) { console.error('IA pompe:', e); }
    setLoadingIA(false);
  };

  const scoreProximite = (p, hmtDemande, debitDemande) => {
    const h = p.hmt_max || p.hmtMax;
    const d = p.debit_max || p.debitMax;
    return (h - hmtDemande) + (d - debitDemande) * 10;
  };

  const rechercher = () => {
    const hmtVal = parseFloat(hmt);
    const debitVal = parseFloat(debit);
    if (!hmtVal || !debitVal) return;
    let compatibles = [];
    if (gamme === 'petite') {
      const surfaceFromDB = pompesDB.filter(p => p.categorie === 'Pompes de Surface').map(p => ({ ...p, type: 'F', hmtMax: p.hmt_max || p.hmtMax || 0, debitMax: p.debit_max || p.debitMax || 0, puissanceW: p.puissance_w || p.puissanceW || 0 }));
      const sourceSurface = surfaceFromDB.length > 0 ? surfaceFromDB : POMPES_SURFACE;
      const sourcePetites = typePompe === 'F' ? sourceSurface : (pompesDB.length > 0 ? pompesDB.filter(p => p.categorie === 'Pompes Solaires DC').map(p => ({ ...p, type: 'S', hmtMax: p.hmt_max || p.hmtMax || 0, debitMax: p.debit_max || p.debitMax || 0 })) : PETITES_POMPES);
      compatibles = sourcePetites.filter(p =>
        (typePompe === 'F' ? (p.type === 'F' || p.type === 'surface') : p.type === 'S') &&
        (p.hmt_max || p.hmtMax) >= hmtVal &&
        (p.debit_max || p.debitMax) >= debitVal
      ).sort((a, b) => scoreProximite(a, hmtVal, debitVal) - scoreProximite(b, hmtVal, debitVal));
    } else {
      const sourceGrandes = pompesDB.length > 0 ? pompesDB.filter(p => p.categorie === 'Pompes Solaires AC') : GRANDES_POMPES;
      compatibles = sourceGrandes.filter(p =>
        (p.hmt_max || p.hmtMax) >= hmtVal &&
        (p.debit_max || p.debitMax) >= debitVal
      ).sort((a, b) => scoreProximite(a, hmtVal, debitVal) - scoreProximite(b, hmtVal, debitVal));
    }
    setResultats(compatibles);
    setSelectionne(null);
    setShowTous(false);
  };

  // Arrondit au multiple de 50 superieur
  const arrondi50 = (x) => Math.ceil(x / 50) * 50;

  // Calcule les lignes d'accessoires pour une pompe AC (9 ou 10 articles selon nb panneaux)
  // Retourne un tableau d'objets { description, ref, quantity, unitPrice }
  const calculAccessoiresAC = (hmt, nb) => {
    const longueurCable = arrondi50(hmt + 15);
    const lignes = [
      {
        description: 'Câble solaire DC souple 2(1x6)mm² Rouge et Noir',
        ref: 'ACC-CABLE-DC-6MM2',
        quantity: nb * 5, unitPrice: accDB['ACC-CABLE-DC-6MM2'] ?? 2930,
      },
      {
        description: 'Câble Industriel pour Pompe 3(1x16)mm² Rouge/Noir/Vert-Jaune (ho7rn-f v/j)',
        ref: 'ACC-CABLE-IND-16MM2',
        quantity: longueurCable, unitPrice: accDB['ACC-CABLE-IND-16MM2'] ?? 9225,
      },
      {
        description: 'Câble Interrupteur de Niveau d’Eau 2(1x1.5)mm² Rouge et Noir',
        ref: 'ACC-CABLE-NIV-1.5MM2',
        quantity: longueurCable, unitPrice: accDB['ACC-CABLE-NIV-1.5MM2'] ?? 1448,
      },
      {
        description: 'Boîte de raccordement solaire 1000V IP65 - 4 chaînes max',
        ref: 'ACC-BOITE-RACC',
        quantity: 1, unitPrice: accDB['ACC-BOITE-RACC'] ?? 684580,
      },
      {
        description: 'Kit mise à la terre - barrette de coupure + piquet + cosse 1m + tresse cuivre 3m',
        ref: 'ACC-KIT-TERRE',
        quantity: 1, unitPrice: accDB['ACC-KIT-TERRE'] ?? 18760,
      },
      {
        description: 'Lot Tube IRL 3321 souple 50m + manchon + coudes anjou',
        ref: 'ACC-TUBE-IRL-50M',
        quantity: Math.ceil((hmt + 15) / 50), unitPrice: accDB['ACC-TUBE-IRL-50M'] ?? 52800,
      },
      {
        description: 'Tube orange lisse T13 100m - Rayon de cintrage 120mm (NF)',
        ref: 'ACC-TUBE-T13-100M',
        quantity: Math.ceil((hmt + 15) / 100), unitPrice: accDB['ACC-TUBE-T13-100M'] ?? 27400,
      },
      {
        description: 'Lot cable acier inoxydable AISI 316 L210m + serre-cables',
        ref: 'ACC-CABLE-ACIER',
        quantity: Math.ceil((hmt + 15) / 210), unitPrice: accDB['ACC-CABLE-ACIER'] ?? 315460,
      },
    ];
    // Structure PV : metalliques pour petites pompes, inox pour grosses
    if (nb <= 10) {
      lignes.push({
        description: 'Supports PV metalliques (1 par panneau)',
        ref: 'ACC-SUPPORTS-PV-METAL',
        quantity: nb, unitPrice: accDB['ACC-SUPPORTS-PV-METAL'] ?? 25120,
      });
    } else {
      lignes.push({
        description: 'Structure de fixation PV en Acier Inoxydable pour 36 modules',
        ref: 'ACC-STRUCTURE-PV-INOX',
        quantity: Math.ceil(nb / 36), unitPrice: accDB['ACC-STRUCTURE-PV-INOX'] ?? 721456,
      });
    }
    return lignes;
  };

  const calculerKit = (pompe) => {
    const pw = pompe.puissance_w || (gamme === 'petite' ? pompe.puissanceW : pompe.puissanceKw * 1000);
    const prixPompe = pompe.prix || (gamme === 'petite' ? pompe.prix : prixVente(pompe.prixUSD));
    const nb = nbPanneaux(pw);
    const acc = pompe.accessoires || accessoires(pw);
    const inst = pompe.installation || installation(pw);
    const total = acc && inst ? prixPompe + nb * (accDB['JKM545M-72HL4-BDVP'] ?? PANNEAU_PRIX) + acc + inst : null;
    return { prixPompe, nb, acc, inst, total, pw };
  };

  const handleSelectionner = (pompe) => {
    const kit = calculerKit(pompe);
    setSelectionne({ pompe, kit });
  };

  const handleInserer = () => {
    if (!selectionne) return;
    const { pompe, kit } = selectionne;
    const nb = kit.nb;
    const prixPompe = kit.prixPompe;
    const gammeLabel = gamme === 'petite' ? 'PSBENZ' : ('Smart Pro ' + (pompe.gamme || 'G3'));
    const debitH = parseFloat(debit) || 0;
    const roi = kit.total ? calculerROI(kit.pw, debitH, kit.total, settings) : null;

    const items = [
      {
        _titre: true,
        description: 'KIT POMPE SOLAIRE ' + gammeLabel + ' TAKOUSSANE ENERGY | HMT: ' + hmt + 'm | Débit: ' + debit + 'm³/h | ' + pompe.ref,
        quantity: 1, unitPrice: 0,
      },
      {
        description: pompe.nom + '\nRef: ' + pompe.ref,
        quantity: 1, unitPrice: prixPompe,
        image: getProductImage(pompe.ref),
      },
      {
        description: (accNomDB['JKM545M-72HL4-BDVP'] || 'Panneau Jinko Tiger Neo 545Wc') + '\nRef: JKM545M-72HL4-BDVP',
        quantity: nb, unitPrice: accDB['JKM545M-72HL4-BDVP'] ?? PANNEAU_PRIX,
        image: getProductImage('JKM545M-72HL4-BDVP'),
      },
            ...(gamme === 'petite' ? [{
        description: 'Accessoires Kit Pompe Solaire DC | Boîte jonction 2.5-6mm² & Connecteurs MC4 | Set de câble électrique max. 50m | Tuyau de refoulement max. 50m | Structure de fixation des panneaux PV',
        quantity: 1, unitPrice: kit.acc || 0,
        image: getProductImage('ACCESSOIRES-KIT-POMPE-DC'),
      }] : calculAccessoiresAC(parseFloat(hmt), nb).map(l => ({
        description: l.description,
        quantity: l.quantity, unitPrice: l.unitPrice,
        image: getProductImage(l.ref),
      }))),
      {
        description: (accNomDB['PRESTA-INSTALL-PV'] || 'Installation, Tests et Mise en service'),
        quantity: 1, unitPrice: kit.inst || 0,
        image: getProductImage('PRESTA-INSTALL-PV'),
      },
    ];

    // Stocker ROI dans localStorage pour ConfirmationPage
    if (roi && kit.total) {
      localStorage.setItem('roiPompe', JSON.stringify({
        pompeRef: pompe.ref,
        puissanceW: kit.pw,
        debitH,
        totalKit: kit.total,
        roi,
      }));
    }

    onSelect(items);
    onClose();
  };

  const top3 = resultats ? resultats.slice(0, 3) : [];
  const autres = resultats ? resultats.slice(3) : [];
  const affiches = showTous ? resultats : top3;

  // ROI preview pour la pompe selectionnee
  const roiPreview = selectionne && selectionne.kit.total
    ? calculerROI(selectionne.kit.pw, parseFloat(debit) || 0, selectionne.kit.total, settings)
    : null;

  const roiMoisLabel = (mois) => {
    if (mois <= 12) return mois + ' mois';
    const ans = Math.floor(mois / 12);
    const m = mois % 12;
    return m > 0 ? ans + ' an' + (ans > 1 ? 's' : '') + ' ' + m + ' mois' : ans + ' an' + (ans > 1 ? 's' : '');
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, padding: '16px', fontFamily: 'Segoe UI, sans-serif'
    }}>
      <div style={{
        background: 'white', borderRadius: '16px', width: '100%', maxWidth: '760px',
        maxHeight: '92vh', display: 'flex', flexDirection: 'column',
        boxShadow: '0 8px 40px rgba(0,0,0,0.2)'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #0369a1, #0ea5e9)',
          padding: '20px 24px', borderRadius: '16px 16px 0 0',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Droplets size={24} color="white" />
            <div>
              <h2 style={{ color: 'white', fontSize: '18px', fontWeight: 700, margin: 0 }}>
                Dimensionnement Pompe Solaire
              </h2>
              <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px', margin: 0 }}>
                Saisissez HMT + debit pour trouver la pompe adaptee
              </p>
            </div>
            <button onClick={() => setShowIA(!showIA)} style={{ background: showIA ? 'linear-gradient(135deg,#7c3aed,#a855f7)' : 'white', border: 'none', borderRadius: '8px', padding: '6px 14px', color: showIA ? 'white' : '#7c3aed', fontSize: '12px', fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', marginLeft: '0' }}>✨ IA</button>
          </div>
          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white',
            borderRadius: '8px', padding: '8px', cursor: 'pointer',
            display: 'flex', alignItems: 'center'
          }}>
            <X size={18} />
          </button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
          <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
            {[
              { val: 'petite', label: 'Pompes Solaires DC', sub: 'PSBENZ — jusqu\'a 1500W' },
              { val: 'grande', label: 'Pompes Solaires AC', sub: 'Smart Pro G3/G4 — 1.1 a 45kW' },
            ].map(g => (
              <button key={g.val} onClick={() => { setGamme(g.val); setResultats(null); setSelectionne(null); }}
                style={{
                  flex: 1, padding: '12px 16px', borderRadius: '10px', cursor: 'pointer',
                  border: gamme === g.val ? '2px solid #0369a1' : '2px solid #e5e7eb',
                  background: gamme === g.val ? '#eff6ff' : 'white', textAlign: 'left',
                  transition: 'all 0.15s'
                }}>
                <div style={{ fontWeight: 700, fontSize: '13px', color: gamme === g.val ? '#0369a1' : '#374151' }}>
                  {g.label}
                </div>
                <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '2px' }}>{g.sub}</div>
              </button>
            ))}
          </div>

          {gamme === 'petite' && (
            <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
              {[
                { val: 'S', label: 'Pompe Immergée', sub: 'Puits / Forage' },
                { val: 'F', label: 'Pompe de Surface', sub: "DC jusquà 750W / AC jusquà 37kW" },
              ].map(t => (
                <button key={t.val} onClick={() => { setTypePompe(t.val); setResultats(null); setSelectionne(null); }}
                  style={{
                    flex: 1, padding: '10px 16px', borderRadius: '10px', cursor: 'pointer',
                    border: typePompe === t.val ? '2px solid #0369a1' : '2px solid #e5e7eb',
                    background: typePompe === t.val ? '#eff6ff' : 'white', textAlign: 'left',
                  }}>
                  <div style={{ fontWeight: 600, fontSize: '13px', color: typePompe === t.val ? '#0369a1' : '#374151' }}>
                    {t.label}
                  </div>
                  <div style={{ fontSize: '11px', color: '#9ca3af' }}>{t.sub}</div>
                </button>
              ))}
            </div>
          )}

          {showIA && (
            <div style={{ background: 'linear-gradient(135deg,#f5f3ff,#ede9fe)', border: '1px solid #c4b5fd', borderRadius: '12px', padding: '16px', marginBottom: '16px' }}>
              <div style={{ fontWeight: 700, fontSize: '13px', color: '#5b21b6', marginBottom: '4px' }}>✨ Décris le projet, l'IA s'occupe du reste</div>
              <div style={{ fontSize: '11px', color: '#7c3aed', marginBottom: '10px' }}>Ex: puits de 45m de profondeur, besoin de 2m3/h pour irrigation maraîchage à Thiès</div>
              <textarea value={promptIA} onChange={e => setPromptIA(e.target.value)} rows={2}
                placeholder="Décris le projet de pompage..."
                style={{ width: '100%', boxSizing: 'border-box', border: '1px solid #c4b5fd', borderRadius: '8px', padding: '8px', fontSize: '13px', outline: 'none', background: 'white', resize: 'none', fontFamily: 'inherit' }} />
              <button onClick={analyserIA} disabled={loadingIA || !promptIA.trim()}
                style={{ marginTop: '8px', width: '100%', padding: '9px', background: loadingIA ? '#a78bfa' : 'linear-gradient(135deg,#7c3aed,#a855f7)', border: 'none', borderRadius: '8px', color: 'white', fontSize: '13px', fontWeight: 700, cursor: loadingIA ? 'wait' : 'pointer' }}>
                {loadingIA ? '⏳ Analyse...' : '✨ Analyser'}
              </button>
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: '12px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#374151', marginBottom: '4px' }}>
                HMT (m) — Hauteur manometrique totale
              </label>
              <input type="number" value={hmt} onChange={e => setHmt(e.target.value)}
                placeholder="ex: 52" min="1"
                style={{ width: '100%', boxSizing: 'border-box', border: '1px solid #e5e7eb',
                  borderRadius: '8px', padding: '10px 12px', fontSize: '14px', outline: 'none' }}
                onFocus={e => e.target.style.borderColor = '#0369a1'}
                onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#374151', marginBottom: '4px' }}>
                Debit souhaite (m3/h)
              </label>
              <input type="number" value={debit} onChange={e => setDebit(e.target.value)}
                placeholder="ex: 1.5" min="0.1" step="0.1"
                style={{ width: '100%', boxSizing: 'border-box', border: '1px solid #e5e7eb',
                  borderRadius: '8px', padding: '10px 12px', fontSize: '14px', outline: 'none' }}
                onFocus={e => e.target.style.borderColor = '#0369a1'}
                onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <button onClick={rechercher} disabled={!hmt || !debit}
                style={{
                  padding: '10px 20px', borderRadius: '8px', border: 'none',
                  background: hmt && debit ? '#0369a1' : '#e5e7eb',
                  color: hmt && debit ? 'white' : '#9ca3af',
                  cursor: hmt && debit ? 'pointer' : 'default',
                  fontWeight: 700, fontSize: '14px',
                  display: 'flex', alignItems: 'center', gap: '6px'
                }}>
                <Search size={16} /> Rechercher
              </button>
            </div>
          </div>

          {resultats !== null && (
            <div>
              {resultats.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '32px', color: '#9ca3af',
                  background: '#f9fafb', borderRadius: '12px' }}>
                  <Droplets size={40} style={{ marginBottom: '12px', opacity: 0.4 }} />
                  <p style={{ fontWeight: 600 }}>Aucune pompe compatible trouvee</p>
                  <p style={{ fontSize: '13px' }}>Essayez des valeurs HMT ou debit differentes.</p>
                </div>
              ) : (
                <>
                  <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '12px' }}>
                    <strong>{resultats.length}</strong> pompe(s) compatible(s) — la mieux dimensionnee est en tête
                  </p>
                  {affiches.map((pompe) => {
                    const kit = calculerKit(pompe);
                    const isSelected = selectionne?.pompe.ref === pompe.ref;
                    const hmtVal = pompe.hmt_max || pompe.hmtMax;
                    const debitVal = pompe.debit_max || pompe.debitMax;
                    const puissanceVal = pompe.puissance_w || pompe.puissanceW;
                    return (
                      <div key={pompe.ref} onClick={() => handleSelectionner(pompe)}
                        style={{
                          border: isSelected ? '2px solid #0369a1' : '1px solid #e5e7eb',
                          borderRadius: '12px', padding: '16px', marginBottom: '10px',
                          cursor: 'pointer', transition: 'all 0.15s',
                          background: isSelected ? '#eff6ff' : pompe.vedette ? '#fafffe' : 'white',
                        }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                              {resultats && resultats[0]?.ref === pompe.ref && (
                                <span style={{ background: '#0369a1', color: 'white', fontSize: '10px',
                                  fontWeight: 700, padding: '2px 8px', borderRadius: '20px' }}>
                                  RECOMMANDEE
                                </span>
                              )}
                              {pompe.vedette && (
                                <span style={{ background: '#ea580c', color: 'white', fontSize: '10px',
                                  fontWeight: 700, padding: '2px 8px', borderRadius: '20px' }}
                                  title="Pompe a ecouler en priorite (instruction Direction)">
                                  DESTOCKAGE
                                </span>
                              )}
                              <span style={{ fontSize: '13px', fontWeight: 700, color: '#1e40af' }}>{pompe.ref}</span>
                            </div>
                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '10px' }}>
                              <span style={{ background: '#dbeafe', color: '#1e40af', fontSize: '11px', fontWeight: 600, padding: '3px 10px', borderRadius: '20px' }}>HMT max : {hmtVal}m</span>
                              <span style={{ background: '#d1fae5', color: '#065f46', fontSize: '11px', fontWeight: 600, padding: '3px 10px', borderRadius: '20px' }}>Debit max : {debitVal}m3/h</span>
                              <span style={{ background: '#fef3c7', color: '#92400e', fontSize: '11px', fontWeight: 600, padding: '3px 10px', borderRadius: '20px' }}>Puissance : {puissanceVal}W</span>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
                              {[
                                ['Pompe', fmt(kit.prixPompe)],
                                ['Panneaux (x' + kit.nb + ')', fmt(kit.nb * (accDB['JKM545M-72HL4-BDVP'] ?? PANNEAU_PRIX))],
                                ['Accessoires', fmt(kit.acc)],
                                ['Installation', fmt(kit.inst)],
                              ].map(([label, val]) => (
                                <div key={label} style={{ background: '#f3f4f6', borderRadius: '6px', padding: '6px 8px' }}>
                                  <div style={{ fontSize: '10px', color: '#9ca3af' }}>{label}</div>
                                  <div style={{ fontSize: '12px', fontWeight: 600, color: '#374151' }}>{val}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div style={{ textAlign: 'right', marginLeft: '16px', flexShrink: 0 }}>
                            <div style={{ fontSize: '11px', color: '#9ca3af' }}>Total kit</div>
                            <div style={{ fontSize: '18px', fontWeight: 800, color: '#0369a1' }}>{fmt(kit.total)}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {autres.length > 0 && (
                    <button onClick={() => setShowTous(!showTous)}
                      style={{ width: '100%', padding: '10px', border: '1px dashed #d1d5db',
                        borderRadius: '8px', background: 'white', cursor: 'pointer',
                        color: '#6b7280', fontSize: '13px', fontWeight: 600,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                      {showTous ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                      {showTous ? 'Masquer les autres modeles' : 'Voir ' + autres.length + ' autre(s) pompe(s) compatible(s)'}
                    </button>
                  )}
                </>
              )}
            </div>
          )}

          {/* ── ROI Preview ── */}
          {roiPreview && (
            <div style={{ marginTop: '20px' }}>
              <div style={{ fontWeight: 700, fontSize: '14px', color: '#1f2937', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ background: '#0369a1', color: 'white', borderRadius: '6px', padding: '2px 8px', fontSize: '12px' }}>ROI</span>
                Retour sur investissement — 3 scenarios
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
                {/* Scenario SEN'EAU */}
                <div style={{ background: '#eff6ff', borderRadius: '12px', padding: '14px', border: '1px solid #bfdbfe' }}>
                  <div style={{ fontWeight: 700, fontSize: '12px', color: '#0369a1', marginBottom: '8px' }}>
                    Remplacement SEN'EAU
                  </div>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '8px' }}>
                    Volume : {roiPreview.seneau.volumeJour} m3/jour ({roiPreview.seneau.volumeMois} m3/mois)<br/>
                    Tarif : {fmtN(roiPreview.seneau.prixM3)} FCFA/m3
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: 800, color: '#0369a1' }}>{fmtN(roiPreview.seneau.ecoMois)} FCFA/mois</div>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>ROI : {roiMoisLabel(roiPreview.seneau.roiMois)}</div>
                  <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    {[[5,'5 ans'],[10,'10 ans'],[15,'15 ans']].map(([a,l]) => (
                      <div key={a} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px' }}>
                        <span style={{ color: '#9ca3af' }}>Economies {l}</span>
                        <span style={{ fontWeight: 600, color: '#065f46' }}>{fmtN(roiPreview.seneau['eco'+a])} FCFA</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Scenario Gasoil */}
                <div style={{ background: '#fefce8', borderRadius: '12px', padding: '14px', border: '1px solid #fde68a' }}>
                  <div style={{ fontWeight: 700, fontSize: '12px', color: '#92400e', marginBottom: '8px' }}>
                    Remplacement Groupe Electrogene
                  </div>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '8px' }}>
                    Gasoil economise : {roiPreview.gasoil.litresJour} L/jour ({roiPreview.gasoil.litresMois} L/mois)<br/>
                    Tarif : {fmtN(roiPreview.gasoil.prixLitre)} FCFA/litre
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: 800, color: '#d97706' }}>{fmtN(roiPreview.gasoil.ecoMois)} FCFA/mois</div>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>ROI : {roiMoisLabel(roiPreview.gasoil.roiMois)}</div>
                  <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    {[[5,'5 ans'],[10,'10 ans'],[15,'15 ans']].map(([a,l]) => (
                      <div key={a} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px' }}>
                        <span style={{ color: '#9ca3af' }}>Economies {l}</span>
                        <span style={{ fontWeight: 600, color: '#065f46' }}>{fmtN(roiPreview.gasoil['eco'+a])} FCFA</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Scenario Electrique */}
                <div style={{ background: '#f0fdf4', borderRadius: '12px', padding: '14px', border: '1px solid #bbf7d0' }}>
                  <div style={{ fontWeight: 700, fontSize: '12px', color: '#065f46', marginBottom: '8px' }}>
                    Remplacement Pompe Electrique
                  </div>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '8px' }}>
                    Consommation evitee : {roiPreview.elec.kwhMois} kWh/mois<br/>
                    Tarif SENELEC : {roiPreview.elec.tarifKwh} FCFA/kWh
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: 800, color: '#10b981' }}>{fmtN(roiPreview.elec.ecoMois)} FCFA/mois</div>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>ROI : {roiMoisLabel(roiPreview.elec.roiMois)}</div>
                  <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    {[[5,'5 ans'],[10,'10 ans'],[15,'15 ans']].map(([a,l]) => (
                      <div key={a} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px' }}>
                        <span style={{ color: '#9ca3af' }}>Economies {l}</span>
                        <span style={{ fontWeight: 600, color: '#065f46' }}>{fmtN(roiPreview.elec['eco'+a])} FCFA</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ── Bouton insertion ── */}
          {selectionne && (
            <div style={{ marginTop: '20px', padding: '16px', background: '#eff6ff',
              borderRadius: '12px', border: '1px solid #bfdbfe' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <p style={{ fontWeight: 700, color: '#1e40af', margin: 0 }}>
                    {selectionne.pompe.ref + ' s' + String.fromCharCode(233) + 'lectionn' + String.fromCharCode(233) + 'e'}
                  </p>
                  <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0' }}>
                    {selectionne.kit.nb + ' panneaux 545Wc — Total : ' + fmt(selectionne.kit.total)}
                  </p>
                </div>
                <button onClick={handleInserer}
                  style={{ padding: '12px 24px', background: '#0369a1', color: 'white',
                    border: 'none', borderRadius: '8px', fontWeight: 700, fontSize: '14px',
                    cursor: 'pointer', transition: 'background 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#075985'}
                  onMouseLeave={e => e.currentTarget.style.background = '#0369a1'}>
                  Inserer dans le devis
                </button>
              </div>
            </div>
          )}
        </div>

        <div style={{ padding: '12px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
          <button onClick={onClose}
            onMouseEnter={e => e.currentTarget.style.background='#f3f4f6'}
            onMouseLeave={e => e.currentTarget.style.background='white'}
            style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: '8px',
              padding: '8px 20px', fontSize: '13px', cursor: 'pointer', fontWeight: 500, transition: 'all 0.15s' }}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default DimensionnementPompeModal;
